<template>
  <b-overlay opacity="0.8">
    <validation-observer ref="form_ref">
      <b-card v-if="consultationData" class="rounded-lg">
        <template #header>
          <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
            <h4 class="text-dark m-0">
              Diagnostics/Investigations
            </h4>
          </div>
        </template>

        <div class="" style="height: 480px; overflow-y: scroll;">
          <b-overlay :show="loading" opacity="0.5">  
            <div>
              <list-table
                :records="records" 
                :columns="tableColumns"
                :current-page-number="1"
                :show-import-button="false"
                :show-export-button="false"
                :show-search="false"
                :total-records="totalRecords"
                @row-clicked="onViewUpload"
              >
                <template #cell(lab)="data">
                  <b-link
                    :to="null"
                    class="font-weight-bold d-block text-nowrap text-primary"
                  >
                    {{ sentenceCase(getValueFromSource(data.item, 'lab_name')) }}
                  </b-link>
                </template>

                <template #cell(note)="data">
                  <span v-if="getValueFromSource(data.item, 'lab_note')">
                    {{ sentenceCase(getValueFromSource(data.item, 'lab_note')) }}
                  </span>
                  <span v-else>-</span>
                </template>

                <template #cell(doctor_note)="data">
                  <span v-if="getValueFromSource(data.item, 'doctor_note')">
                    {{ sentenceCase(getValueFromSource(data.item, 'doctor_note')) }}
                  </span>
                  <span v-else>-</span>
                </template>

                <template #cell(status)="data">
                  <b-badge
                    v-if="getValueFromSource(data.item, 'status')"
                    pill
                    :variant="resolveStatusVariant(getValueFromSource(data.item, 'status'))"
                    class="text-capitalize"
                  >
                    {{ getUserStatusText(getValueFromSource(data.item, 'status')) }}
                  </b-badge>
                  <span v-else>-</span>
                </template>
              </list-table>
            </div>
          </b-overlay>
        </div>
      </b-card>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BLink,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BOverlay,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormTextarea,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

import { get } from 'lodash';
import { heightTransition } from '@core/mixins/ui/transition';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import ListTable from "@/@core/components/ListTable/ListTable.vue";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BOverlay,
    BDropdown,
    BFormGroup,
    BFormTextarea,
    BDropdownItem,
    BFormInvalidFeedback,
    ListTable,
    BLink,
    
    // validations
    ValidationProvider,
    ValidationObserver
  },
  mixins: [heightTransition],
  props: {
    consultationData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      labRequestId: null,

      toggleModal: false,
      toggleUploadModal: false,

      records: [],
      tableColumns: [
        { key: 'lab', label: 'Lab', sortable: false, },
        { key: 'lab_category_title', label: 'Category', sortable: false, },
        { key: 'lab_type_name', label: 'Type', sortable: false, },
        { key: 'doctor_note', label: 'Note', sortable: false, },
        { key: 'note', label: 'Lab Note', sortable: false, },
        { key: 'status', label: 'Status', sortable: false, },
        { key: 'created', label: 'Date', sortable: false, formatter: val => `${this.formatDate(val, 'MM-yy')}`, class: 'w-10' },
      ],
    }
  },
  computed: {
    totalRecords: {
      get(){
        return this.$store.getters[`navigation/totalRecords`];
      },
      set(value){
        this.$store.commit(`navigation/UPDATE_TOTAL_RECORDS`, value)
      }
    },
  },
  created() {
    this.fetchAllData();
  },
  methods: {
    async fetchAllData() {
      try {
        this.loading = true; 

        const query = {
          page: 1,
          limit: 100,
          consultation_id: this.consultationData._id,
        }

        const response = await this.useJwt().mainService.labRequests.list(query)
        const { data, pagination } = response.data;
        this.records = data;
        this.totalRecords = pagination.totalRecords
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    onViewUpload(lab_request){
      this.labRequestId = lab_request._id
      this.toggleUploadModal = true;
    },
  }
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}
</style>
